import React from "react"


import {FieldCSVImportPreviewProps} from "../../../../render/csv-import-preview";
import GDProjectName from "../../../../../gd-ui/project-name/project-name";

export default function FieldTaskParent_CSVImportPreview(props:FieldCSVImportPreviewProps) {

    const value = props.field.getViewValue(props.model)

    if (!value) {
        return (
            <div className="ui5-txt-less-important-small txt-truncate">
                No parent
            </div>
        );
    }

    const showIcon          = true //_.get(props,'options.showIcon', false)
    // const colorize          = _.get(props,'options.colorize', false)

    return <GDProjectName className="ui5-txt-less-important-small"
                          projectId={value}
                          type="ui5-prop"
                          hintFullPath={true} />

    // return <FieldProject_ViewSmall {...props} />

}
